import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Camera } from "lucide-react";

function mediaUrl(u) {
  if (!u) return u;
  if (u.startsWith("http")) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u}`;
}

export default function ProductGallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gallery").then((r) => {
      setItems(r.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <section className="py-16 lg:py-24 bg-[#FBF8F3]" data-testid="product-gallery">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#9E3B21] mb-3 flex items-center gap-2">
              <Camera className="w-3.5 h-3.5" /> Straight from the kitchen
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold">Photo & Video Gallery</h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {items.map((it, i) => (
            <figure
              key={it.id}
              data-testid={`gallery-item-${i}`}
              className={`relative rounded-2xl overflow-hidden bg-[#F4EFE6] border border-[#E6DEC3] group ${
                i % 5 === 0 ? "row-span-2 aspect-[3/4] md:aspect-[3/5]" : "aspect-square"
              }`}
            >
              {it.type === "video" ? (
                <video
                  src={mediaUrl(it.url)}
                  className="w-full h-full object-cover"
                  playsInline
                  muted
                  loop
                  autoPlay
                  preload="metadata"
                />
              ) : (
                <img
                  src={mediaUrl(it.url)}
                  alt={it.caption || "Gallery"}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              )}
              {it.caption ? (
                <figcaption className="absolute bottom-0 inset-x-0 p-3 bg-gradient-to-t from-black/70 to-transparent text-white text-xs">
                  {it.caption}
                </figcaption>
              ) : null}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
